import { defineStore } from "pinia";
import type { Balance, Ledger, Profile } from "@/types/account";
import type Transaction from "@/classes/Transaction.ts";
import { useTransactions } from "@/stores/transactions.ts";
import date from "@/libs/date.ts";

export const useAccount = defineStore("Account", {
  state: () => ({
    initialBalance: 0,
    runningBalance: 0,
    features: [] as Feature[],
    ledgers: [] as Ledger[],
    profile: null as Profile | null,
  }),

  getters: {
    defaultLedger(state) {
      return state.ledgers.find((ledger: Ledger) => ledger.isDefault) ?? state.ledgers[0];
    },
  },

  actions: {
    setBalance(balance: Balance) {
      this.initialBalance = balance;
      this.resetBalance();
    },

    setFeatures(features: Feature[]) {
      this.features = features;
    },

    setProfile(profile: Profile) {
      this.profile = profile;
    },

    getBalanceAfterTransaction(tx: Transaction) {
      if (date(tx.date).isBefore(date(), "day")) {
        return this.runningBalance;
      }

      const sign = tx.type === "expense" ? -1 : 1;

      if (!tx.isDisabled) {
        this.runningBalance = this.runningBalance + sign * tx.amount;
      }

      return this.runningBalance;
    },

    resetBalance() {
      this.runningBalance = structuredClone(this.initialBalance);

      const transactions = useTransactions();

      transactions.calculateBalances();
    },

    setLedgers(ledgers: Ledger[]) {
      this.ledgers = ledgers;
    },
  },
});
